module.exports = __webpack_public_path__ + "static/img/bg-tr.d680356a.png";